var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAds(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 18C8.95 18 8.47933 17.8043 8.088 17.413C7.696 17.021 7.5 16.55 7.5 16V4C7.5 3.45 7.696 2.979 8.088 2.587C8.47933 2.19567 8.95 2 9.5 2H18.5C19.05 2 19.521 2.19567 19.913 2.587C20.3043 2.979 20.5 3.45 20.5 4V16C20.5 16.55 20.3043 17.021 19.913 17.413C19.521 17.8043 19.05 18 18.5 18H9.5ZM9.5 16H18.5V4H9.5V16ZM5.5 22C4.95 22 4.479 21.8043 4.087 21.413C3.69567 21.021 3.5 20.55 3.5 20V6H5.5V20H16.5V22H5.5Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAds);
export default __webpack_public_path__ + "static/media/ads.b2ac6398f5658bb90552475736731c06.svg";
export { ForwardRef as ReactComponent };